module.exports = {"data":{"contributionsJson":{"name":"candel","www_url":"http://i-love-u.ch","thema":"10","issue_month":"August","issue_year":2007,"issue_date":200708,"artist":"ruth","location":"Switzerland","email":"ruth@i-love-u.ch","id":"contribution_303","media_type":"still_image","position_in_section":5,"media_uri":"media/2007/August/still_image/party6 Kopie.jpg","media_th_uri":"media/2007/August/still_image/tn_party6 Kopie.jpg","still_image_count":11,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_303"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/issue-200708-still-image-5.json
// module id = 955
// module chunks = 160300089918730